<template>
  <div class="alertBox1">
    <dialogWrap
      v-model="show"
      title="新增保单信息"
      :width="'824px'"
      @change="dialoagChange"
    >
      <el-form
        label-position="right"
        :model="formLabelAlign"
        ref="formAddPolicy"
        :rules="rules"
        class="addPolicy"
        label-width="110px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="`车牌号${columnSeparator}`"
              class="alone"
              prop="plateNo"
            >
              <CarSelect
                :modelValue="formLabelAlign.carId"
                :getCarDetail="true"
                :plateNo="formLabelAlign.plateNo"
                :disabled="!!plateNo"
                @update:modelValue="val => { formLabelAlign.carId = val }"
                @change="SelectChange"></CarSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'品牌' + columnSeparator"
              prop="brandName"
            >
              <span>{{ formLabelAlign.brandName || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="'车系' + columnSeparator"
              prop="seriesName"
            >
              <span>{{ formLabelAlign.seriesName || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="'车型' + columnSeparator"
              prop="carModelName"
            >
              <span>{{ formLabelAlign.carModelName || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="'车辆ID' + columnSeparator" prop="carId">
              <span>{{ formLabelAlign.carId || '--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`保险类型${columnSeparator}`" prop="type">
              <el-select
                placeholder="请选择"
                v-model="formLabelAlign.type"
                clearable
              >
                <el-option
                  v-for="item in insuranceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="`保单号${columnSeparator}`" prop="policyNo">
              <el-input
                v-model="formLabelAlign.policyNo"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="`保费${columnSeparator}`" prop="premium">
              <el-input
                v-model="formLabelAlign.premium"
                placeholder="请输入"
                v-limit-money="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="`保险公司${columnSeparator}`"
              prop="providerId"
            >
              <el-select
                placeholder="请选择"
                v-model="formLabelAlign.providerId"
                clearable
              >
                <el-option
                  v-for="item in insuranceCompanyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`开始时间${columnSeparator}`"
              prop="startDate"
            >
              <el-date-picker
                v-model="formLabelAlign.startDate"
                type="date"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd"
                :picker-options="startTimeLimit"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="`结束时间${columnSeparator}`" prop="endDate">
              <el-date-picker
                v-model="formLabelAlign.endDate"
                type="date"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd"
                :picker-options="endTimeLimit"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="`备注${columnSeparator}`"
              class="alone"
              prop="remarks"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model="formLabelAlign.remarks"
                maxlength="500"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="`保单附件${columnSeparator}`" class="alone">
              <UploadCommon
                :fileList="fileList"
                listType="text"
                :limit="20"
                :sizeType="4"
                commonUpload
                group="assert"
                code="assert_guarantee_slip"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button @click="closePolicy" size="small">取消</el-button>
        <el-button
          :loading="loading.submit"
          type="primary"
          @click="addPolicy"
          size="small"
          >确认新增</el-button
        >
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import { providerList } from '@/api/company'
import {
  policyAdd,
} from '@/api/serviceAPi'

export default {
  model: {
    prop: 'addInsuranceShow',
    event: 'change',
  },
  props: {
    addInsuranceShow: {
      type: Boolean,
      default: false,
    },
    plateNo: {
      type: String,
      default: '',
    },
  },
  watch: {
    addInsuranceShow(val) {
      this.show = val
    },
    show(val) {
      this.$emit('change', val)
    },
    plateNo(val) {
      this.formLabelAlign.plateNo = val
    },
  },
  data() {
    return {
      show: false,
      fileList: [],
      carList: [], // 车辆模糊查询列表
      insuranceCompanyList: [], // 保险公司列表
      // 弹框表单的数据
      formLabelAlign: {
        plateNo: this.plateNo,
        brandName: '',
        seriesName: '',
        carModelName: '',
        id: '',
        carId: '',
        type: '',
        policyNo: '',
        premium: '',
        providerId: '',
        startDate: '',
        endDate: '',
        remarks: '',
        attachment: '',
      },
      rules: {
        carId: [
          { required: true, message: '车牌号不能为空', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '保险类型不能为空', trigger: 'change' },
        ],
        policyNo: [
          { required: true, message: '保单号不能为空', trigger: 'blur' },
          { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' },
        ],
        premium: [{ required: true, message: '保费不能为空', trigger: 'blur' }],
        providerId: [
          { required: true, message: '保险公司不能为空', trigger: 'change' },
        ],
        startDate: [
          { required: true, message: '开始时间不能为空', trigger: 'blur' },
        ],
        endDate: [
          { required: true, message: '结束时间不能为空', trigger: 'blur' },
        ],
        remarks: [{ required: false, message: '备注不能为空', trigger: 'blur' }],
      },
      loading: {
        submit: false,
      },
    }
  },
  computed: {
    insuranceList() {
      return this.dictParseList(selectOption.insuranceTypeDict)
    },
    // 开始时间
    startTimeLimit() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const endTime = this.formLabelAlign.endDate
          if (endTime) {
            return time > new Date(endTime).getTime()
          }
        },
      }
    },
    // 结束时间
    endTimeLimit() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const startTime = this.formLabelAlign.startDate
          if (startTime) {
            return time < new Date(startTime).getTime()
          }
        },
      }
    },
  },
  methods: {
    // dialog 显示隐藏触发
    dialoagChange(state) {
      if (!state) {
        this.$refs.formAddPolicy.resetFields()
        this.fileList = []
      }
    },
    /* 确定新增按钮 */
    addPolicy() {
      this.formLabelAlign.attachment = this.getUoloadCommonFileData(
        this.fileList,
      )
      this.$refs.formAddPolicy.validate((valid) => {
        if (valid) {
          this.addPolicyFun()
        }
      })
    },
    /* 新增保单接口 */
    async addPolicyFun() {
      // eslint-disable-next-line vue/no-mutating-props
      this.loading.submit = true
      try {
        const data = await policyAdd({
          ...this.formLabelAlign,
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.submit = false
        if (data.code === 1) {
          this.show = false
          this.$refs.formAddPolicy.resetFields()
          this.fileList = []
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      } catch (error) {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.submit = false
      }
    },
    /* 取消保单 */
    closePolicy() {
      this.show = false
      this.$refs.formAddPolicy.resetFields()
      this.carList = []
    },
    /* 获取保险公司 */
    async getProvider() {
      const { code, data } = await providerList({
        serviceType: 2,
        state: 1,
      })
      if (code !== 1) return
      this.insuranceCompanyList = data ? data?.items : []
    },
    /* 车牌号改变后发送请求 */
    SelectChange(_, carInfo) {
      this.formLabelAlign.carModelName = carInfo.modelName
      this.formLabelAlign.plateNo = carInfo.plateNo
      this.formLabelAlign.brandName = carInfo.brandName
      this.formLabelAlign.seriesName = carInfo.seriesName
    },
  },
  created() {
    this.getProvider()
  },
}
</script>

<style lang="scss" scoped>
.alertBox1 {
  p {
    margin: 0;
  }
}
::v-deep .el-input--small {
  width: 220px;
}

::v-deep .el-input--small {
  width: 220px;
}
</style>
